import { BaseValidator } from '../core/BaseValidator.js';
import { ValidationResult } from '../core/ValidationResult.js';

/**
 * UK NINO validator following Single Responsibility Principle
 */
export class NinoValidator extends BaseValidator {
  constructor() {
    super({
      name: 'UK National Insurance Number',
      pattern: /^[A-CEGHJ-PR-TW-Z][A-CEGHJ-NPR-TW-Z]\d{6}[A-D]$/i,
      length: 9
    });

    this.invalidPrefixes = ['BG', 'GB', 'NK', 'KN', 'TN', 'NT', 'ZZ'];
  }

  validateFormat(id) {
    const upperCaseId = id.toUpperCase();
    
    // Check length
    const lengthValidation = this.validateLength(upperCaseId, this.config.length);
    if (!lengthValidation.isValid) {
      return lengthValidation;
    }

    // Check pattern
    const patternValidation = this.validateRegex(
      upperCaseId,
      this.config.pattern,
      'NINO format must be 2 letters, 6 digits, and 1 letter (A-D)'
    );
    if (!patternValidation.isValid) {
      return patternValidation;
    }

    // Check for invalid prefixes
    const prefix = upperCaseId.substring(0, 2);
    if (this.invalidPrefixes.includes(prefix)) {
      return ValidationResult.invalid(`Invalid NINO prefix: ${prefix}`);
    }

    return ValidationResult.valid();
  }

  validateChecksum(id) {
    // NINO doesn't have a mathematical checksum
    return ValidationResult.valid('Valid NINO');
  }
}